import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    // Use static HTML login page instead of Vue component
    beforeEnter() {
      window.location.href = '/login.html';
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    // JSP handles authentication - no Vue auth check needed
  },
  {
    path: '/staff',
    name: 'StaffManagement',
    component: () => import('@/views/staff/StaffManagement.vue'),
    // JSP handles authentication - no Vue auth check needed
  },
  {
    path: '/schedule',
    name: 'Schedule',
    // Use static HTML schedule page instead of Vue component
    beforeEnter() {
      window.location.href = '/fullStatic-schedule-onserver.html';
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/views/Settings.vue'),
    // JSP handles authentication - no Vue auth check needed
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
